import React, { useMemo } from "react";
import useGetter from "../../../../../hooks/queryResults/useGetter";
import Table from "../../../../layout/Table";
import Loading from "../../../../ui/Loading";

export default function AdminRemoteAllNflPlayersTable() {
  const { data: playersData, query: playersQuery } =
    useGetter("/nfl/players/all");

  const playersTableColumns = useMemo(
    () => [
      { Header: "CBS", accessor: "cbs" },
      { Header: "FP", accessor: "fp" },
      { Header: "PFR", accessor: "pfr" },
      { Header: "Pos", accessor: "pos" },
      { Header: "First", accessor: "firstName", className: "left" },
      { Header: "Last", accessor: "lastName", className: "left" },
      { Header: "Team", accessor: "nflFranchiseAbbr" },
    ],
    []
  );

  const playersTableData = useMemo(() => {
    if (!playersData) return [];
    return playersData.nflPlayers.map((nflPlayer) => ({
      cbs: nflPlayer.cbsId,
      fp: nflPlayer.fpId,
      pfr: nflPlayer.pfrId,
      pos: nflPlayer.pos,
      firstName: nflPlayer.firstName,
      lastName: nflPlayer.lastName,
      nflFranchiseAbbr: nflPlayer.nflFranchiseAbbr,
    }));
  }, [playersData]);

  return playersQuery.isLoading ? (
    <Loading />
  ) : (
    <Table columns={playersTableColumns} data={playersTableData} />
  );
}
